import { Initial } from '@/components/paper'
import type { Me } from '@/lib/api'
import { circleStyle, useCircleColor } from '@/lib/circleColor'
import { cn } from '@/lib/utils'
import type { CircleColor } from '../../../shared/circleColors'

// You, where you open your profile and switch circles: your picture, ringed in the colour of the circle you're in, so
// it quietly says where you are on every page.
export function YouFace({ me, className, plain }: { me: Me; className?: string; plain?: boolean }) {
  const color = useCircleColor()
  return (
    <span
      aria-hidden="true"
      data-circle={plain ? undefined : (color ?? undefined)}
      className={cn('grid shrink-0 rounded-full', color && !plain && 'circle-ring', className)}
      style={color ? circleStyle(color) : undefined}
    >
      <Initial name={me.name} portrait={me.portrait} className="size-full text-[1em]" />
    </span>
  )
}

// A circle's colour as a small ring, beside its name in the list of your circles and in Circle settings.
export function CircleDot({ color, className }: { color: CircleColor; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn('circle-dot block size-5 shrink-0 rounded-full', className)}
      style={circleStyle(color)}
    />
  )
}
